<template>
  <section class="section-product-detail-page bg-grey">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12">
          <div class="content">
            <div class="page-title text-center pb-0">
              <ContentsCapitalLabel
                label="SEE HOW OUR PRODUCTS ARE USED IN YOUR APPLICATIONS"
                :is-secondary-color="true"
              />
              <h2 class="section-title h2 text-center text-black f-44 h2-caslon">Use Case</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-grey section-gallery-usecase pt-0">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12 gallery-container">
          <div class="content">
            <h2 class="section-title gallery-title text-center text-black ff-myriad-pro mt-0">Automotive and E-Mobility</h2>
          </div>

          <div class="content">
            <div class="section-divider"></div>
          </div>

          <ContentsCard :contents="AutomotiveAndEMobility" :max="6"/>
          
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-grey section-gallery-usecase pt-0">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12 gallery-container">
          <div class="content">
            <h2 class="section-title gallery-title text-center text-black ff-myriad-pro mt-0">Electrical and Electronics</h2>
          </div>

          <div class="content pt-0">
            <div class="section-divider mt-0"></div>
          </div>

          <ContentsCard :contents="ElectricalAndElectronics"  />
          
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-grey section-gallery-usecase pt-0">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12 gallery-container">
          <div class="content">
            <h2 class="section-title gallery-title text-center text-black ff-myriad-pro mt-0">Healthcare</h2>
          </div>

          <div class="content">
            <div class="section-divider"></div>
          </div>

          <ContentsCard :contents="Healthcare"  />
          
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-grey section-gallery-usecase pt-0">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12 gallery-container">
          <div class="content">
            <h2 class="section-title gallery-title text-center text-black ff-myriad-pro mt-0">Industrial</h2>
          </div>

          <div class="content">
            <div class="section-divider"></div>
          </div>

          <ContentsCard :contents="Industrial"  />
          
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-grey section-gallery-usecase pt-0">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12 gallery-container">
          <div class="content">
            <h2 class="section-title gallery-title text-center text-black ff-myriad-pro mt-0">Infrastructure</h2>
          </div>

          <div class="content pt-0">
            <div class="section-divider mt-0"></div>
          </div>

          <ContentsCard :contents="Infrastructure"  />
          
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-grey section-gallery-usecase py-0">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12 gallery-container">
          <div class="content">
            <h2 class="section-title gallery-title text-center text-black ff-myriad-pro mt-0">Material Solutions</h2>
          </div>

          <div class="content pt-0">
            <div class="section-divider mt-0"></div>
          </div>

          <ContentsCard :contents="MaterialSolutions" :max="3" />
          
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-grey section-gallery-usecase pt-0">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12 gallery-container">
          <div class="content">
            <h2 class="section-title gallery-title text-center text-black ff-myriad-pro mt-0">Sustainable Materials</h2>
          </div>

          <div class="content pt-0">
            <div class="section-divider mt-0"></div>
          </div>

          <ContentsCard :contents="SustainableMaterials" />
          
        </div>
      </div>
    </div>
  </section>

</template>
<style scoped>
.sub-title{
  letter-spacing: -1px !important;
  font-size: 32px ;
}

.page-title {
  padding: 50px 0;
}

.section-title {
  margin: 40px 0 30px;
}

.section-title.gallery-title {
  margin-bottom: 25px;
}

.section-divider {
  margin: 14px auto;
}

.section-gallery-usecase {
  padding: 60px 0;
}
</style>
<style>
.section-gallery-usecase .card-image .card-content {
  min-height: 242px;
  align-items: flex-start;
}
</style>
<script setup>
useHead({
  title:'Use Cases - NAGASE THAILAND Engineering Plastics',
})
const AutomotiveAndEMobility = [
  {
    'img': '/pages/products/use-cases/w01.jpg',
    'title': 'ADAS',
    'to': '/use-cases/adas',
  },
  {
    'img': '/pages/products/use-cases/b02.jpg',
    'title': 'EV and Electrification',
    'to': '/use-cases/ev-electrification',
  },
  {
    'img': '/pages/products/use-cases/b03.jpg',
    'title': 'Exterior',
    'to': '/use-cases/exterior',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/b04.jpg',
    'title': 'Interior',
    'to': '/pages/products/use-cases/Interior.pdf',
  },
  {
    'img': '/pages/products/use-cases/b01.jpg',
    'title': 'Under the hood and Powertrain',
    'to': '/use-cases/under-the-hood-powertrain',
  },
]

const ElectricalAndElectronics = [
  {
    'pdf': true,
    'img': '/pages/products/use-cases/bk01.jpg',
    'title': 'EXTEM™ RH1016UCL resin for Fiber Optical Components',
    'to': '/wp-content/uploads/2022/08/EXTEM%E2%84%A2%20RH1016UCL%20resin%20for%20Fiber%20Optical%20Components%20(2).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/bk02.jpg',
    'title': 'Innovative ULTEM™ Resins for Advanced Connectors',
    'to': '/wp-content/uploads/2022/08/Innovative%20ULTEM%E2%84%A2%20Resins%20for%20Advanced%20Connectors.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/s01.jpg',
    'title': 'LNP™ Copolymer Resins Solutions in Consumer Electronics Industry',
    'to': '/wp-content/uploads/2022/08/LNP%E2%84%A2%20Copolymer%20Resins%20Solutions%20in%20Consumer%20Electronics%20Industry%20(3).pdf',
  },
]
const Healthcare = [
  {
    'pdf': true,
    'img': '/pages/products/use-cases/v01.jpg',
    'title': 'DuPont Performance Materials delivers science-based, high quality thermoplastics to the healthcare industry.',
    'to': '/wp-content/uploads/2022/08/DuPont_Healthcare_Brochure_FNL.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/d01.jpg',
    'title': 'LNP™ EXL Copolymer Resins for Healthcare',
    'to': '/wp-content/uploads/2022/08/LNP%E2%84%A2%20EXL%20Copolymer%20Resins%20for%20Healthcare%20(1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/Screen-Shot-2565-08-03-at-15.17.55.png',
    'title': 'SABIC LNP ELCRES CRX Copolymer Resins',
    'to': '/wp-content/uploads/2022/08/SABIC%20LNP%20ELCRES%20CRX%20Copolymer%20Resins%20(3).pdf',
  },
]

const Industrial = [
  {
    'pdf': true,
    'img': '/pages/products/use-cases/b08.jpg',
    'title': 'Material Solutions for the Food & Water Industries',
    'to': '/wp-content/uploads/2022/08/MM_FoodWaterBrochure_Web_RevFNL.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/u01.jpg',
    'title': 'NEW SABIC® PP PHC60 Polymer for frozen food thin wall packaging',
    'to': '/wp-content/uploads/2022/08/SABIC%C2%AE%20PP%20PHC60%20Polymer%20for%20Frozen%20Food%20Packaging.pdf',
  },
]

const Infrastructure = [
  {
    'pdf': true,
    'img': '/pages/products/use-cases/xs01.jpg',
    'title': 'Drinking Water applications up to 85°C',
    'to': '/wp-content/uploads/2022/08/Drinking%20Water%20applications%20up%20to%2085%C2%B0C%20(4).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/wq01.jpg',
    'title': 'NORYL™ Resin Biofouling Resistance Properties',
    'to': '/wp-content/uploads/2022/08/NORYL%E2%84%A2%20RESIN%20BIOFOULING%20RESISTANCE%20PROPERTIES%20(1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/b09.jpg',
    'title': 'ULTEM and EXTEM resin in Photonics Applications',
    'to': '/wp-content/uploads/2022/08/ULTEM%20and%20EXTEM%20resin%20in%20Photonics%20Applications%20(1).pdf',
  },
]

const MaterialSolutions = [
  {
    'pdf': true,
    'img': '/pages/products/use-cases/ty02.jpg',
    'title': 'SABIC® PP Compounds Brochure',
    'to': '/wp-content/uploads/2022/08/SABIC%C2%AE%20PP%20Compounds%20Brochure.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/b10.jpg',
    'title': 'LEXAN™ EXL Resin Brochure',
    'to': '/wp-content/uploads/2022/08/LEXAN%E2%84%A2%20EXL%20Resin%20Brochure.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/ty01.jpg',
    'title': 'Automotive Advantages - NORYL Resin Solutions',
    'to': '/wp-content/uploads/2022/08/Automotive%20Advantages%20%20-%20NORYL%20Resin%20Solutions%20(2).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/feaung.jpg',
    'title': 'Advanced LNP Solutions for Plastic Gears',
    'to': '/pages/products/use-cases/Advanced_LNP_Solutions_for_Plastic_Gears_(1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/mocomb.jpg',
    'title': 'THERMOCOMP™ Compounds for Dielectric Solutions',
    'to': '/pages/products/use-cases/THERMOCOMP™ Compounds for Dielectric Solutions (1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/led.jpg',
    'title': 'CXT resins  New Generation of High Heat Copolymer',
    'to': '/pages/products/use-cases/CXT resins – New Generation of High Heat Copolymer.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/say.jpg',
    'title': 'Electrical Friendly Product Sheet NA FNL',
    'to': '/pages/products/use-cases/Electrical Friendly Product Sheet NA FNL.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/load.jpg',
      'title': 'LNP Compounds-Wear and\n' +
        'Friction solutions-Bearings bushings cams sliders',
    'to': '/pages/products/use-cases/LNP Compounds-Wear and Friction solutions-Bearings bushings cams sliders (1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/toe.jpg',
    'title': 'LNP Compounds-Wear and Friction solutions-High temperature materials ',
    'to': '/pages/products/use-cases/LNP Compounds-Wear and Friction solutions-High temperature materials (1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/lui.jpg',
    'title': 'LNP Compounds-Wear and Friction solutions-Lubriloy alloy technology',
    'to': '/pages/products/use-cases/LNP Compounds-Wear and Friction solutions-Lubriloy alloy technology (1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/SAS.jpg',
    'title': 'LNP Compounds-Wear and Friction solutions-Thermoplastic Gearing',
    'to': '/pages/products/use-cases/LNP Compounds-Wear and Friction solutions-Thermoplastic Gearing (1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/dsa.jpg',
    'title': 'LNP novel low warp products',
    'to': '/pages/products/use-cases/LNP novel low warp products.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/sabic.jpg',
    'title': 'LNP™ compounds and copolymers alternatives for PA66 compounds',
    'to': '/pages/products/use-cases/LNP™ compounds and copolymers alternatives for PA66 compounds (1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/phan.jpg',
    'title': 'LNP™ FARADEX™ Compounds ',
    'to': '/pages/products/use-cases/LNP™ FARADEX™ Compounds (4).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/phome.jpg',
    'title': 'Product Brochure SABIC® PP-UMS',
    'to': '/pages/products/use-cases/Product Brochure SABIC® PP-UMS-en (3).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/drives.jpg',
    'title': 'SABIC LEXAN™ CXT Resins Product Brochure',
    'to': '/pages/products/use-cases/SABIC LEXAN™ CXT Resins Product Brochure (5).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/mobil2.jpg',
    'title': 'ULTEM™ Resin An Alternative Solution to Sulfone Polymers ',
    'to': '/pages/products/use-cases/ULTEM™ Resin_ An Alternative Solution to Sulfone Polymers (1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/solar.jpg',
    'title': 'STAMAX™ RESINS (Long glass fiber reinforced PP)',
    'to': '/pages/products/use-cases/STAMAX™ RESINS (LONG GLASS FIBER REINFORCED PP) FOR HIGH PERFORMANCE APPLICATIONS WITH POTENTIAL COST SAVINGS (1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/kan.jpg',
    'title': 'Super ductile thin wall Flame Retardant LEXAN EXL9414',
    'to': '/pages/products/use-cases/Super ductile thin wall Flame Retardant LEXAN EXL9414 (1).pdf',
  }
]

const SustainableMaterials = [
  {
    'pdf': true,
    'img': '/pages/products/use-cases/bann01.jpg',
    'title': 'Certified Renewable Polycarbonate Brochure',
    'to': '/wp-content/uploads/2022/08/Certified%20Renewable%20Polycarbonate%20Brochure.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/wq.jpg',
    'title': 'ISCC+ Certified Renewable Bio-based ULTEM™ Resins',
    'to': '/wp-content/uploads/2022/08/ISCC%2B%20Certified%20Renewable%20Bio-based%20ULTEM%E2%84%A2%20Resins.pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/ss01.jpg',
    'title': 'LNP ELCRIN iQ resin for circular solutions',
    'to': '/wp-content/uploads/2022/08/LNP%20ELCRIN%20iQ%20resin%20for%20circular%20solutions%20(1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/k01.jpg',
    'title': 'LNP™ ELCRIN™ iQ Compounds Supporting Food Contact Comp',
    'to': '/wp-content/uploads/2022/08/LNP%E2%84%A2%20ELCRIN%E2%84%A2%20iQ%20Compounds%20%E2%80%93%20Supporting%20Food%20Contact%20Compliance%20(1).pdf',
  },
  {
    'pdf': true,
    'img': '/pages/products/use-cases/k2.jpg',
    'title': 'Specialties Sustainability PCR Mechanical Recycling Portfolio\n',
    'to': '/wp-content/uploads/2022/08/Specialties%20Sustainability%20PCR%20Mechanical%20Recycling%20Portfolio%20(2).pdf',
  },
]
</script>
